import { HTMLProps, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './SectionHeader.module.css';

export interface SectionHeaderProps extends HTMLProps<HTMLDivElement> {
  stickyHeader?: boolean;
}

const SectionHeader = forwardRef<HTMLDivElement, SectionHeaderProps>(
  (props, ref) => {
    const { stickyHeader, className, children, ...rest } = props;

    return (
      <div
        ref={ref}
        data-component="SectionHeader"
        data-sticky={stickyHeader || undefined}
        className={classNames(className, styles.root, {
          [styles.sticky]: stickyHeader,
        })}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

SectionHeader.displayName = 'Section.Header';

export default SectionHeader;
